function prepareOverlay(container, image) {
    container.setAttribute('class', 'image-magnify-full-size');
    container.setAttribute('aria-hidden', 'true');
    container.style.backgroundImage = `url('${image.src}')`;
    container.style.backgroundColor = 'var(--color-bg)';
  }
  
  function toggleLoadingSpinner(image) {
    const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
    loadingSpinner.classList.toggle('hidden');
  }
  
  function moveWithHover(image, event, zoomRatio, overlay) {
    // calculate mouse position
    const ratio = image.height / image.width;
    const container = event.target.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;
    const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;
  
    // determine what to show in the frame
    overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
  }
  
  function magnify(image, zoomRatio, event) {
    // Directly move the logic here that was in createOverlay
    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('src', `${image.src}`);
    
    const overlay = document.createElement('div');
    prepareOverlay(overlay, overlayImage);  // Set up the overlay styles and background
    
    image.style.opacity = '50%';
    toggleLoadingSpinner(image);
  
    overlayImage.onload = () => {
      toggleLoadingSpinner(image);
      image.parentElement.parentElement.insertBefore(overlay, null);  // Insert overlay after image
      image.style.opacity = '100%';
    };

    moveWithHover(image, event, zoomRatio, overlay);
  
    // Attach event listeners to the overlay
    overlay.onclick = () => overlay.remove();
    overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio, overlay);
    overlay.onmouseleave = () => overlay.remove();
  }
  
  function enableZoomOnHover(zoomRatio) {
    const images = document.querySelectorAll('.image-magnify-hover');
    images.forEach((image) => {
      image.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' ) {
          magnify(image, zoomRatio, event);
        }
      });
    });
  }
  
  enableZoomOnHover(2.5);
  